import { render, staticRenderFns } from "./download-apk-wrapper.vue?vue&type=template&id=370d0f17"
import script from "./download-apk-wrapper.vue?vue&type=script&lang=js"
export * from "./download-apk-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports